export const REQUEST_FETCH_CREATE_METRIC_DATA = "request_fetch_create_metric_data "
export const FETCH_CREATE_METRIC_DATA_SUCCESS = "fetch_create_metric_data_success"
export const FETCH_CREATE_METRIC_DATA_FAILURE = "fetch_create_metric_data_failure"

export const CLEAR_FETCH_CREATE_METRIC_DATA = "clear_fetch_create_metric_data"